import type { IAvatarProps } from './Avatar'

import { styled } from '@linaria/react'
import { PosterSC } from 'atoms/ImagePoster'
import { MEDIA } from 'vars/media'

export const AvatarStyled = styled.div<IAvatarProps>`
  --background-default: ${({ backgroundDefault, imageUrl }) =>
    imageUrl ? 'initial' : `var(${backgroundDefault})`};
  width: ${({ width }) => (width ? `${width}px` : 'auto')};
  height: ${({ height }) => (height ? `${height}px` : 'auto')};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ corners }) => `var(${corners})`};
  padding: ${({ paddings }) =>
    paddings && paddings.length
      ? paddings.map((item) => `var(${item})`)?.join(' ')
      : 0};
  border: ${({ borders, borderColor }) =>
    `var(${borders}) solid var(${borderColor})`};
  background-color: var(--background-default);
  position: relative;
  overflow: hidden;

  ${MEDIA.NO_TOUCH} {
    &:hover {
      background-color: ${({ backgroundHovered }) =>
        backgroundHovered
          ? `var(${backgroundHovered})`
          : `var(--background-default)`};
      cursor: ${({ cursor }) => cursor || 'initial'};
    }
  }
  &:active {
    background-color: ${({ backgroundPressed }) =>
      backgroundPressed
        ? `var(${backgroundPressed})`
        : `var(--background-default)`};
  }

  ${PosterSC} {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`
